export default "<!-- <app-hydrosila-header></app-hydrosila-header> -->\r\n\r\n<router-outlet></router-outlet>\r\n"